import classNames from 'classnames';
import type {FC} from 'react';

export const SelectedTheme: FC<{
  themeId: number;
  options: Array<{
    id: number;
    choice: string;
  }>;
}> = ({themeId, options}) => {
  return (
    <div className="flex gap-8 justify-end items-start">
      <div className="flex flex-col gap-8 max-w-3/4 pc:max-w-1/2">
        {options?.map((option) => (
          <div
            key={option.id}
            className={classNames(
              'bg-gradient-to-r from-gradient-ai-l to-gradient-ai-r rounded-full p-[2px]',
              {
                'cursor-pointer': false,
                'cursor-not-allowed': true,
              },
            )}
          >
            <div
              className={classNames('rounded-full px-16 py-8', {
                '': themeId === option.id,
                'bg-white': themeId !== option.id,
              })}
            >
              <div
                className={classNames('text-base', {
                  'text-white': themeId === option.id,
                  'bg-gradient-to-r from-gradient-ai-l to-gradient-ai-r text-transparent bg-clip-text':
                    themeId !== option.id,
                })}
              >
                {option.choice}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
